import { DEVELOPER_LEVEL_ACCESS } from 'src/components/access';
import {
    ARRAY_AREAS,
    BDC_AREA,
    BOTH_AREA,
    DIGITAL_AREA,
    NEW_AREA,
    NEW_USER_AREA,
    PREOWNED_AREA,
    PREOWNED_USER_AREA,
    SERVICE_AREA,
    SHOWROOM_AREA,
} from 'src/constants/store/areas';
import { IUser } from 'src/interfaces/user';

export type TStoreAreaOption = {
    _id: string;
    name: string;
};

/**
 * Resolves which store areas a user can see in filters.
 * Developer → all store areas.
 * Others → mapped from user.areas; digital expands to nuevos/seminuevos via carType.
 */
export const getStoreAreasForUser = (
    user?: IUser | null
): TStoreAreaOption[] => {
    if (!user) return [];

    if (user.accessLevel === DEVELOPER_LEVEL_ACCESS) {
        return ARRAY_AREAS.map((area) => ({ _id: area, name: area }));
    }

    const userAreas = user.areas || [];
    const storeAreas: string[] = [];

    if (userAreas.includes(DIGITAL_AREA)) {
        const carType = user.carType;

        if (carType === BOTH_AREA) {
            storeAreas.push(NEW_AREA, PREOWNED_AREA);
        } else if (carType === NEW_USER_AREA) {
            storeAreas.push(NEW_AREA);
        } else if (carType === PREOWNED_USER_AREA) {
            storeAreas.push(PREOWNED_AREA);
        }
    }

    if (userAreas.includes(NEW_AREA)) {
        storeAreas.push(NEW_AREA);
    }

    if (userAreas.includes(PREOWNED_AREA)) {
        storeAreas.push(PREOWNED_AREA);
    }

    if (userAreas.includes(BDC_AREA)) {
        storeAreas.push(BDC_AREA);
    }

    if (userAreas.includes(SHOWROOM_AREA)) {
        storeAreas.push(SHOWROOM_AREA);
    }

    if (userAreas.includes(SERVICE_AREA)) {
        storeAreas.push(SERVICE_AREA);
    }

    return [...new Set(storeAreas)].map((area) => ({
        _id: area,
        name: area,
    }));
};
